import { useEffect } from "react";

/**
 * The tab title, per route.
 *
 * Replaces Next's `metadata` exports, which were resolved on the server. A
 * single-page app changes the title itself, and it matters more here than it
 * looks: an analyst works with several cases open, and "Case" in every tab is
 * unusable. The template mirrors the one the previous root layout declared.
 */
const SUFFIX = "Underwriting";

export function useDocumentTitle(title: string | null): void {
  useEffect(() => {
    document.title = title ? `${title} · ${SUFFIX}` : "Credit Underwriting Workspace";
  }, [title]);
}
